import { GroupPermissionResponseModel } from "./group-permission-response";
import { GroupResponseModel } from "./group-response";
import { UserPermissionModelForResponse } from "./user-permission-response";

export class UserInfoResponseModel {
  UserId: number;
  CompanyId: number;
  CompanyName: string;
  FirstName: string;
  LastName: string;
  Email: string;
  PhoneNo: string;
  Password: string;
  IsActive: boolean;
  isDeleted: boolean;
  IsForgotPassword: boolean;
  IsLinkExpired: boolean;
  Role: string;
  IsAssociatedWithGroup: boolean;
  GroupId: number;
  LastAccessDate: Date;
  DateTimeCreated: Date;
  DateTimeLastModified: Date;
  IsDocuware: boolean;

  GroupName: string;
  FullName: string;
  token: string;
  tokentype: string;
  refreshtoken : string;
  Group: Array<GroupResponseModel>;
  GroupPermissions: Array<GroupPermissionResponseModel>;
  UserPermissions: Array<UserPermissionModelForResponse>;  
}

export class UserPermissionDisplayResponseModel {
  UserId: number;
  UserName: string;
  IsDelete: boolean;
  IsEdit: boolean;
  IsView: boolean;
  IsViewerEdit: boolean;
  IsViewerDownload: boolean;
  IsViewerPrint: boolean;
  IsViewerSearch: boolean;
  Upload: boolean;
  Store: boolean;
  ViewAnnotation : boolean;
  AddAnnotation : boolean;
  ModifyAnnotation : boolean;
  DeleteAnnotation : boolean;
}
export class ClientCredentialsModel {
  ClientId: string;
  ClientSecret: string;
}

export class UserFileUploadResponseModel {
  TotalRecords: number;
  FailCount: number;
  SuccessCount: number;
  DuplicateCount: number;
}

